import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import actions from '../../../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LeftDrawerSection from '../../../presenters/authed-route-wrapper/left-drawer/LeftDrawerSection/LeftDrawerSection';
import LeftDrawerHeader from '../../../presenters/authed-route-wrapper/left-drawer/LeftDrawerHeader/LeftDrawerHeader';
import LeftDrawerFooter from '../../../presenters/authed-route-wrapper/left-drawer/LeftDrawerFooter/LeftDrawerFooter';
import { CURRENT_THEME } from '../../../../config/index';
import {
  ADMIN_PANEL_URL,
  BRANCH_OVERRIDES,
  COMPLETED_RENEWALS_PORTAL_URL,
  HOME_URL,
  IMITATE_EMPLOYEE_URL,
  INACTIVE_BRANCHES_URL,
  RENEWALS_PORTAL_URL,
  REPORTS_PORTAL_URL,
  SELECT_BRANCHES_URL,
  MANAGED_RESTROOM_SERVICES_URL
} from '../../../../route-names';
import { getBranchRoles, getUser } from '../../../../utils/session-util';

import * as UserType from '../../../../constants/UserType';
import { injectIntl } from 'react-intl';
import { APP_VERSION } from '../../../../constants/constants';
import { RMT } from '../../../../constants/UserType';

const mapMenuItems = (props) =>
  [
    {
      text: props.intl.formatMessage({
        id: 'drawer.imitate_employee'
      }),
      route: IMITATE_EMPLOYEE_URL,
      permittedUserTypes: [UserType.ADMIN]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.admin_panel'
      }),
      route: ADMIN_PANEL_URL,
      permittedUserTypes: [UserType.ADMIN]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.select_branches'
      }),
      route: SELECT_BRANCHES_URL,
      permittedUserTypes: [UserType.ADMIN]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.inactive_branches'
      }),
      route: INACTIVE_BRANCHES_URL,
      permittedUserTypes: [UserType.ADMIN]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.branch_overrides'
      }),
      route: BRANCH_OVERRIDES,
      permittedUserTypes: [UserType.ADMIN]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.dashboard'
      }),
      route: HOME_URL,
      permittedUserTypes: [
        UserType.CSM,
        UserType.COM,
        UserType.GM,
        UserType.CSR,
        UserType.RVP,
        UserType.RMT
      ]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.renewal_portal'
      }),
      route: RENEWALS_PORTAL_URL,
      search: `?contractExpiresBefore=${moment()
        .startOf('d')
        .format('Y-MM-DD')}&title=${props.intl.formatMessage({
        id: 'customer_table_past_due.title'
      })}`,
      permittedUserTypes: [
        UserType.CSM,
        UserType.COM,
        UserType.GM,
        UserType.CSR,
        UserType.RVP,
        UserType.RMT
      ]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.managed_restroom_services_portal'
      }),
      route: MANAGED_RESTROOM_SERVICES_URL,
      permittedUserTypes: [
        UserType.CSM,
        UserType.COM,
        UserType.GM,
        UserType.CSR,
        UserType.CAM,
        UserType.C3,
        UserType.VPO,
        UserType.RVP,
        UserType.RMT
      ]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.completed_renewals_portal_url'
      }),
      route: COMPLETED_RENEWALS_PORTAL_URL,
      permittedUserTypes: [
        UserType.CSM,
        UserType.COM,
        UserType.GM,
        UserType.CSR,
        UserType.ADMIN,
        UserType.CAM,
        UserType.C3,
        UserType.VPO,
        UserType.RVP,
        UserType,RMT
      ]
    },
    {
      text: props.intl.formatMessage({
        id: 'drawer.reports_portal_url'
      }),
      route: REPORTS_PORTAL_URL,
      permittedUserTypes: [
        UserType.CSM,
        UserType.COM,
        UserType.GM,
        UserType.CSR,
        UserType.ADMIN,
        UserType.CAM,
        UserType.C3,
        UserType.VPO,
        UserType.RVP,
        UserType.RMT
      ]
    }
  ].map((item, index) => ({
    ...item,
    index,
    // TODO: this id can definitely be refactored out.
    id: index,
    onClick: () => {
      props.actions.openMenuItem(item);
      props.history.push(
        !!item.search ? `${item.route}${item.search}` : item.route
      );
      if (props.isMobileBrowser) {
        props.handleChangeRequestNavDrawer();
      }
    }
  }));

class LeftDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.toggleMenu = this.toggleMenu.bind(this);

    this.state = {
      isMenuOpen: true,
      menuItems: this.mapMenuItemsOnClick()
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const currentItem = prevState.menuItems.find(
      (item) =>
        nextProps.location.pathname.split('/')[1].split('?')[0] ===
        item.route.substr(1)
    );
    if (currentItem != null) {
      nextProps.actions.openMenuItem(currentItem);
    }
  }

  toggleMenu() {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  }

  mapMenuItemsOnClick() {
    const mappedMenuItems = mapMenuItems(this.props);
    return mappedMenuItems.filter((menuItem) =>
      menuItem.permittedUserTypes.some((pt) =>
        Object.values(getBranchRoles()).some((role) => pt === UserType[role])
      )
    );
  }

  render() {
    const styles = {
      selectedMenuListItem: {
        color: CURRENT_THEME.selectedMenuListItemColor,
        fontSize: 14,
        background: CURRENT_THEME.selectedMenuListItemBackgroundColor
      },
      selectedListItem: {
        color: CURRENT_THEME.selectedListItemColor,
        fontSize: 14,
        background: CURRENT_THEME.selectedListItemBackgroundColor
      }
    };

    return (
      <Drawer
        className={`left-drawer${
          this.props.navDrawerOpen ? ' open' : ' close'
        }`}
        docked
        open={this.props.navDrawerOpen}
      >
        <LeftDrawerHeader user={getUser()} />

        <LeftDrawerSection
          title={'MENU'}
          selectedItemStyle={styles.selectedMenuListItem}
          open={this.state.isMenuOpen}
          onMenuClick={this.toggleMenu}
          isMobileBrowser={this.props.appStore.isMobileBrowser}
          items={this.state.menuItems}
          selectedIndex={this.props.appStore.selectedMenuItemIndex}
        />
        <LeftDrawerFooter
          text={`${this.props.intl.formatMessage({
            id: 'drawer.version'
          })}: ${APP_VERSION}`}
        />
      </Drawer>
    );
  }
}

LeftDrawer.propTypes = {
  navDrawerOpen: PropTypes.bool,
  handleChangeRequestNavDrawer: PropTypes.func
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(LeftDrawer))
);
